module.exports = __webpack_public_path__ + "static/media/ucsb.0b5ccb2a.png";